webpackJsonp([2,47],{

/***/ 1129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = {
  props: ['drawer'],
  data: function data() {
    return {
      drawer: true,
      itemsz: ['General', 'Landing Page'],
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
      items: [{
        icon: 'subscriptions',
        text: 'Activity Stream'
      }, {
        icon: 'collections',
        text: 'Pages',
        link: '/'
      }, {
        icon: 'group',
        text: 'Groups',
        link: '/'
      }, {
        icon: 'event_note',
        text: 'Calendar',
        link: '/'
      }],
      items2: [{
        icon: 'public',
        text: 'General',
        link: '/general'
      }, {
        icon: 'desktop_mac',
        text: 'Appearance',
        link: '/appearance'
      }, {
        icon: 'group_add',
        text: 'Manage Access',
        link: '/priviledge'
      }],
      account: [{
        title: 'My Profile'
      }, {
        title: 'Sign Out'
      }]
    };
  }
};

/***/ }),

/***/ 1146:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = {
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    loading: function loading() {
      return this.$store.getters.getLoading;
    },
    error: function error() {
      return this.$store.getters.getError;
    },
    updateProcess: function updateProcess() {
      return this.$store.getters.getProcess === 'Settings Saved';
    },
    process: function process() {
      return this.$store.getters.getProcess;
    }
  },
  data: function data() {
    return {
      background_image: null,
      log: null,
      status: '',
      font_type: {
        text: ''
      },
      font_types: [{
        text: 'Arial'
      }, {
        text: 'Calibri'
      }, {
        text: 'Open Sans'
      }, {
        text: 'Helvetica'
      }, {
        text: 'Times New Roman'
      }, {
        text: 'Courier'
      }, {
        text: 'Courier New'
      }, {
        text: 'Verdana'
      }, {
        text: 'Georgia'
      }, {
        text: 'Palatino'
      }, {
        text: 'Garamond'
      }, {
        text: 'Bookman'
      }, {
        text: 'Comic Sans Ms'
      }, {
        text: 'Trebuchet MS'
      }, {
        text: 'Impact'
      }, {
        text: 'PT Sans'
      }, {
        text: 'Montserrat'
      }, {
        text: 'League Gothic'
      }, {
        text: 'Signika'
      }, {
        text: 'Josephin Slab'
      }, {
        text: 'Roboto Slab'
      }, {
        text: 'Roboto'
      }, {
        text: 'Roboto Thin'
      }, {
        text: 'Rosario'
      }, {
        text: 'Oswald'
      }]
    };
  },
  mounted: function mounted() {
    this.filename = this.value;
    this.font_type = this.styles.general.font_types;
    this.$store.commit('setLoading', false);
  },
  watch: {
    styles: function styles(val) {}
  },
  methods: {
    submitData: function submitData() {
      var data = {
        type: 'general',
        data: {
          background_color: this.styles.general.background_color,
          background_image: this.styles.general.background_image,
          favicon: this.styles.general.favicon,
          font_color: this.styles.general.font_color,
          font_types: this.font_type,
          font_size: this.styles.general.font_size,
          logo: this.styles.general.logo,
          text: this.styles.general.text,
          theme_color_light: this.styles.general.theme_color_light,
          theme_color_dark: this.styles.general.theme_color_dark
        }
      };
      this.$store.dispatch('saveSettings', data);
    },
    selectFile: function selectFile(refId) {
      this.$refs[refId].click();
    },
    onFileChange: function onFileChange(event) {
      var _this = this;

      var ref = event.target.id;
      var files = event.target.files;
      var fileReader = new FileReader();
      fileReader.addEventListener('load', function () {
        _this.styles.general[ref] = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      var type = "general/".concat(ref);
      var payload = {
        type: type,
        file: files[0]
      };
      this.$store.dispatch('uploadImage', payload);
    }
  }
};

/***/ }),

/***/ 1147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = {
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    loading: function loading() {
      return this.$store.getters.getLoading;
    },
    error: function error() {
      return this.$store.getters.getError;
    },
    updateProcess: function updateProcess() {
      return this.$store.getters.getProcess === 'Settings Saved';
    },
    process: function process() {
      return this.$store.getters.getProcess;
    }
  },
  data: function data() {
    return {
      background_image: null,
      log: null,
      status: '',
      message: '',
      font_type: {
        text: ''
      },
      font_types: [{
        text: 'Arial'
      }, {
        text: 'Calibri'
      }, {
        text: 'Open Sans'
      }, {
        text: 'Helvetica'
      }, {
        text: 'Times New Roman'
      }, {
        text: 'Courier'
      }, {
        text: 'Courier New'
      }, {
        text: 'Verdana'
      }, {
        text: 'Georgia'
      }, {
        text: 'Palatino'
      }, {
        text: 'Garamond'
      }, {
        text: 'Bookman'
      }, {
        text: 'Comic Sans Ms'
      }, {
        text: 'Trebuchet MS'
      }, {
        text: 'Impact'
      }, {
        text: 'PT Sans'
      }, {
        text: 'Montserrat'
      }, {
        text: 'League Gothic'
      }, {
        text: 'Signika'
      }, {
        text: 'Josephin Slab'
      }, {
        text: 'Roboto Slab'
      }, {
        text: 'Roboto Thin'
      }, {
        text: 'Rosario'
      }, {
        text: 'Oswald'
      }]
    };
  },
  watch: {
    value: function value(v) {
      this.filename = v;
    }
  },
  mounted: function mounted() {
    this.filename = this.value;
    this.font_type = this.styles.landing.font_types;
    this.$store.commit('setLoading', false);
  },
  methods: {
    submitData: function submitData() {
      var data = {
        type: 'landing',
        data: {
          background_color: this.styles.landing.background_color,
          background_image: this.styles.landing.background_image,
          font_color: this.styles.landing.font_color,
          font_types: this.font_type,
          font_size: this.styles.landing.font_size,
          text: this.styles.landing.text
        }
      };
      this.$store.dispatch('saveSettings', data);
    },
    selectFile: function selectFile(refId) {
      this.$refs[refId].click();
    },
    onFileChange: function onFileChange(event) {
      var _this = this;

      var ref = event.target.id;
      var files = event.target.files; // let filename = files[0].name

      if (!files[0].type.match('image.*')) {// return message please upload a valid file
      }

      var fileReader = new FileReader();
      fileReader.addEventListener('load', function () {
        _this.styles.landing[ref] = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      var type = "general/".concat(ref);
      var payload = {
        type: type,
        file: files[0]
      };
      this.$store.dispatch('uploadImage', payload);
    }
  }
};

/***/ }),

/***/ 1154:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".navigation-drawer{position:fixed}.menu__content{background-color:#595959}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Components/NavBar.vue"],"names":[],"mappings":"AACA,mBACE,cAAgB,CACjB,AACD,eACE,wBAAkC,CACnC","file":"NavBar.vue","sourcesContent":["\n.navigation-drawer {\n  position: fixed;\n}\n.menu__content {\n  background-color: rgb(89, 89, 89);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1165:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, "input[type=file][data-v-7d075b73]{position:absolute;left:-99999px}input[type=color][data-v-7d075b73]{width:80px;height:40px;margin-right:20px;margin-top:10px}.uploadFile[data-v-7d075b73]{cursor:pointer;width:250px}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Appearance/landing.vue"],"names":[],"mappings":"AACA,kCACE,kBAAmB,AACnB,aAAe,CAChB,AACD,mCACE,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,eAAiB,CAClB,AACD,6BACE,eAAgB,AAChB,WAAa,CACd","file":"landing.vue","sourcesContent":["\ninput[type=file][data-v-7d075b73] {\n  position: absolute;\n  left: -99999px;\n}\ninput[type=color][data-v-7d075b73] {\n  width: 80px;\n  height: 40px;\n  margin-right: 20px;\n  margin-top: 10px;\n}\n.uploadFile[data-v-7d075b73] {\n  cursor: pointer;\n  width: 250px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1170:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, "div[data-v-d8734c78]{text-align:center}.progress-circular[data-v-d8734c78]{margin:1rem}input[type=file][data-v-d8734c78]{position:absolute;left:-99999px}input[type=color][data-v-d8734c78]{width:80px;height:66px;margin-right:20px;margin-top:14px;margin-left:-3px;outline:none}.general-app-logo-card[data-v-d8734c78]{width:intrinsic;width:-moz-max-content;width:-webkit-max-content}.general-app-logo[data-v-d8734c78]{position:relative;padding:10px;overflow:hidden;width:590px;display:-webkit-box;display:-ms-flexbox;display:flex}.uploadFile[data-v-d8734c78]{cursor:pointer;width:250px}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Appearance/general.vue"],"names":[],"mappings":"AACA,qBACE,iBAAmB,CACpB,AACD,oCACE,WAAa,CACd,AACD,kCACE,kBAAmB,AACnB,aAAe,CAChB,AACD,mCACE,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,gBAAiB,AACjB,iBAAkB,AAClB,YAAc,CACf,AACD,wCACE,gBAAiB,AACjB,uBAAwB,AACxB,yBAA2B,CAC5B,AACD,mCACE,kBAAmB,AACnB,aAAc,AACd,gBAAiB,AACjB,YAAa,AACb,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,6BACE,eAAgB,AAChB,WAAa,CACd","file":"general.vue","sourcesContent":["\ndiv[data-v-d8734c78] {\n  text-align: center;\n}\n.progress-circular[data-v-d8734c78] {\n  margin: 1rem;\n}\ninput[type=file][data-v-d8734c78] {\n  position: absolute;\n  left: -99999px;\n}\ninput[type=color][data-v-d8734c78] {\n  width: 80px;\n  height: 66px;\n  margin-right: 20px;\n  margin-top: 14px;\n  margin-left: -3px;\n  outline: none;\n}\n.general-app-logo-card[data-v-d8734c78] {\n  width: intrinsic;\n  width: -moz-max-content;\n  width: -webkit-max-content;\n}\n.general-app-logo[data-v-d8734c78] {\n  position: relative;\n  padding: 10px;\n  overflow: hidden;\n  width: 590px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.uploadFile[data-v-d8734c78] {\n  cursor: pointer;\n  width: 250px;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1176:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1154);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("eba27c92", content, true, {});

/***/ }),

/***/ 1187:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1165);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("1555ec07", content, true, {});

/***/ }),

/***/ 1192:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1170);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("616938ef", content, true, {});

/***/ }),

/***/ 1199:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1192)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1146),
  /* template */
  __webpack_require__(1239),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d8734c78",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1200:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1187)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1147),
  /* template */
  __webpack_require__(1232),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7d075b73",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1201:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1176)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1129),
  /* template */
  __webpack_require__(1220),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1220:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('v-navigation-drawer', {
    staticClass: "pb-0",
    attrs: {
      "persistent": "",
      "height": "100%",
      "clipped": "",
      "absolute": "",
      "enable-resize-watcher": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-avatar', [_c('img', {
    attrs: {
      "src": 'https://randomuser.me/api/portraits/men/38.jpg',
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-list-tile-title', [_vm._v("User")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v(" Categories ")]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.text,
      staticClass: "mt-3"
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n            " + _vm._s(item.text) + "\n          ")])], 1)], 1)
  }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-subheader', [_vm._v(" Settings ")]), _vm._v(" "), _vm._l((_vm.items2), function(item) {
    return _c('v-list-tile', {
      key: item.text,
      staticClass: "mt-3",
      attrs: {
        "to": item.link
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      staticClass: "grey--text text--darken-1"
    }, [_vm._v(_vm._s(item.icon) + "\n          ")])], 1), _vm._v(" "), _c('v-list-tile-title', {
      staticClass: "grey--text text--darken-1"
    }, [_vm._v("\n          " + _vm._s(item.text) + "\n        ")])], 1)
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "fixed": ""
    }
  }, [_c('v-toolbar-title', [_c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v("\n      Logo\n    ")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-menu', {
    attrs: {
      "bottom": "",
      "right": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": "",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "text--darken-2",
    attrs: {
      "left": ""
    }
  }, [_vm._v("account_circle")]), _vm._v("\n          My Account\n        ")], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "color": "white"
    }
  }, _vm._l((_vm.account), function(item) {
    return _c('v-list-tile', {
      key: item.title
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(item.title))])], 1)
  }), 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1232:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card', {
    staticClass: "bordered-card"
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n        Landing Page Settings\n      ")])], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-3 mb-4",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('p', {
    staticClass: "settings-label subheader text-xs-right"
  }, [_vm._v("Background Image")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4",
    attrs: {
      "x2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "x3": ""
    }
  }, [_c('v-card', [_c('v-card-media', {
    attrs: {
      "src": _vm.styles.landing.background_image,
      "height": "200px"
    }
  }), _vm._v(" "), _c('v-card-actions', {
    staticClass: "white"
  }, [_c('v-btn', {
    style: ({
      backgroundColor: _vm.styles.general.theme_color_light
    }),
    attrs: {
      "dark": "",
      "raised": ""
    },
    on: {
      "click": function($event) {
        return _vm.selectFile('fileInput-bg')
      }
    }
  }, [_vm._v("Change Image")]), _vm._v(" "), _c('input', {
    ref: "fileInput-bg",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*",
      "id": "background_image"
    },
    on: {
      "change": _vm.onFileChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "x9": ""
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('p', {
    staticClass: "settings-label subheader text-xs-right"
  }, [_vm._v("Background Color")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Background Color"
    },
    model: {
      value: (_vm.styles.landing.background_color),
      callback: function($$v) {
        _vm.$set(_vm.styles.landing, "background_color", $$v)
      },
      expression: "styles.landing.background_color"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.styles.landing.background_color),
      expression: "styles.landing.background_color"
    }],
    ref: "fileColor",
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": (_vm.styles.landing.background_color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.styles.landing, "background_color", $event.target.value)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-4",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('p', {
    staticClass: "settings-label subheader text-xs-right"
  }, [_vm._v("Font Types")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-select', {
    staticClass: "mt-0",
    attrs: {
      "items": _vm.font_types,
      "label": "Select",
      "item-value": "text"
    },
    model: {
      value: (_vm.font_type),
      callback: function($$v) {
        _vm.font_type = $$v
      },
      expression: "font_type"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "text-xs-left pl-4",
    attrs: {
      "xs3": "",
      "offset-xs3": "",
      "justify-start": true
    }
  }, [_c('v-btn', {
    style: ({
      backgroundColor: _vm.styles.general.theme_color_light
    }),
    attrs: {
      "loading": _vm.loading,
      "color": "primary",
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitData.apply(null, arguments)
      }
    }
  }, [_vm._v("\n              Save\n              "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1239:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card', {
    staticClass: "bordered-card"
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n          General Settings\n        ")])], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('p', {
    staticClass: "settings-label subheader text-xs-right"
  }, [_vm._v("Logo")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4",
    attrs: {
      "x2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "x3": ""
    }
  }, [_c('v-card', {
    staticClass: "general-app-logo-card"
  }, [_c('div', {
    staticClass: "general-app-logo primary"
  }, [_c('img', {
    attrs: {
      "src": _vm.styles.general.logo
    }
  })]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "white"
  }, [_c('v-btn', {
    style: ({
      backgroundColor: _vm.styles.general.theme_color_light
    }),
    attrs: {
      "dark": "",
      "raised": ""
    },
    on: {
      "click": function($event) {
        return _vm.selectFile('fileInput-logo')
      }
    }
  }, [_vm._v("Change Image")]), _vm._v(" "), _c('input', {
    ref: "fileInput-logo",
    attrs: {
      "type": "file",
      "id": "logo",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "x9": ""
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-4",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('p', {
    staticClass: "settings-label subheader text-xs-right"
  }, [_vm._v("Background Image")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4",
    attrs: {
      "x2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "x3": ""
    }
  }, [_c('v-card', [_c('v-card-media', {
    attrs: {
      "src": _vm.styles.general.background_image,
      "height": "200px"
    }
  }), _vm._v(" "), _c('v-card-actions', {
    staticClass: "white"
  }, [_c('v-btn', {
    style: ({
      backgroundColor: _vm.styles.general.theme_color_light
    }),
    attrs: {
      "dark": "",
      "raised": ""
    },
    on: {
      "click": function($event) {
        return _vm.selectFile('fileInput-bg')
      }
    }
  }, [_vm._v("Change Image")]), _vm._v(" "), _c('input', {
    ref: "fileInput-bg",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*",
      "id": "background_image"
    },
    on: {
      "change": _vm.onFileChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "x9": ""
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-4",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('p', {
    staticClass: "settings-label subheader text-xs-right"
  }, [_vm._v("Favicon")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4",
    attrs: {
      "x2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "x3": ""
    }
  }, [_c('v-card', [_c('img', {
    attrs: {
      "src": _vm.styles.general.favicon,
      "width": "100px",
      "height": "100px"
    }
  }), _vm._v(" "), _c('v-card-actions', {
    staticClass: "white"
  }, [_c('v-btn', {
    style: ({
      backgroundColor: _vm.styles.general.theme_color_light
    }),
    attrs: {
      "dark": "",
      "raised": ""
    },
    on: {
      "click": function($event) {
        return _vm.selectFile('fileInput-favicon')
      }
    }
  }, [_vm._v("Change Favicon")]), _vm._v(" "), _c('input', {
    ref: "fileInput-favicon",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*",
      "id": "favicon"
    },
    on: {
      "change": _vm.onFileChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "x9": ""
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-4",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('p', {
    staticClass: "settings-label subheader text-xs-right"
  }, [_vm._v("Background Color")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-layout', {
    staticClass: "color-control",
    attrs: {
      "row": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "label": "Background Color",
      "value": _vm.styles.general.background_color
    },
    model: {
      value: (_vm.styles.general.background_color),
      callback: function($$v) {
        _vm.$set(_vm.styles.general, "background_color", $$v)
      },
      expression: "styles.general.background_color"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.styles.general.background_color),
      expression: "styles.general.background_color"
    }],
    ref: "fileColor",
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": (_vm.styles.general.background_color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.styles.general, "background_color", $event.target.value)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-4",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('p', {
    staticClass: "settings-label subheader text-xs-right"
  }, [_vm._v("Main Theme Color")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-layout', {
    staticClass: "color-control",
    attrs: {
      "row": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "label": "Main Theme Color"
    },
    model: {
      value: (_vm.styles.general.theme_color_light),
      callback: function($$v) {
        _vm.$set(_vm.styles.general, "theme_color_light", $$v)
      },
      expression: "styles.general.theme_color_light"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.styles.general.theme_color_light),
      expression: "styles.general.theme_color_light"
    }],
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": (_vm.styles.general.theme_color_light)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.styles.general, "theme_color_light", $event.target.value)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-4",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('p', {
    staticClass: "settings-label subheader text-xs-right"
  }, [_vm._v("Sub Theme Color")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-layout', {
    staticClass: "color-control",
    attrs: {
      "row": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "box": "",
      "label": "Sub Theme Color"
    },
    model: {
      value: (_vm.styles.general.theme_color_dark),
      callback: function($$v) {
        _vm.$set(_vm.styles.general, "theme_color_dark", $$v)
      },
      expression: "styles.general.theme_color_dark"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.styles.general.theme_color_dark),
      expression: "styles.general.theme_color_dark"
    }],
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": (_vm.styles.general.theme_color_dark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.styles.general, "theme_color_dark", $event.target.value)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-4",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('p', {
    staticClass: "settings-label subheader text-xs-right"
  }, [_vm._v("Font Types")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-select', {
    staticClass: "mt-0",
    attrs: {
      "items": _vm.font_types,
      "label": "Select",
      "item-value": "text"
    },
    model: {
      value: (_vm.font_type),
      callback: function($$v) {
        _vm.font_type = $$v
      },
      expression: "font_type"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "text-xs-left pl-4",
    attrs: {
      "xs3": "",
      "offset-xs3": "",
      "justify-start": true
    }
  }, [_c('v-btn', {
    style: ({
      backgroundColor: _vm.styles.general.theme_color_light
    }),
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.loading,
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitData.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                Save\n                "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    Block: __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue___default.a
  },
  props: ['settings'],
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    loading: function loading() {
      return this.$store.getters.getLoading;
    },
    error: function error() {
      return this.$store.getters.getError;
    },
    updateProcess: function updateProcess() {
      return this.$store.getters.getProcess === 'Settings Saved';
    },
    process: function process() {
      return this.$store.getters.getProcess;
    }
  },
  data: function data() {
    return {
      status: '',
      items: ['Edit DoD Contract Analytics Page Text']
    };
  },
  methods: {
    submitData: function submitData(values) {
      this.$store.dispatch('savePageSettings', values);
    }
  }
};

/***/ }),

/***/ 1294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator__);



var _data$mounted$compute;


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = _data$mounted$compute = {
  data: function data() {
    return {
      requestEmailReceivers: [],
      companySubmissionEmailReceivers: [],
      saving: false
    };
  },
  mounted: function mounted() {
    this.$store.dispatch('loadUsers');
  },
  computed: {
    adminUsers: function adminUsers() {
      var users = this.$store.getters.fetchUsers;
      var adminUsers = users.filter(function (user) {
        return Number(user.role) === 1;
      }).map(function (user) {
        return {
          uid: user.uid,
          fullName: "".concat(user.firstname, " ").concat(user.lastname),
          avatar: user.avatar.indexOf('https') >= 0 ? user.avatar : "".concat(window.location.host, "/").concat(user.avatar)
        };
      });
      return adminUsers;
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_data$mounted$compute, "mounted", function mounted() {
  this.getEmailReceivers();
}), __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(_data$mounted$compute, "methods", {
  getEmailReceivers: function getEmailReceivers() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee() {
      var snapshot, receivers, snackbar;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _this.$firebase.database().ref('email_receivers').once('value');

            case 3:
              snapshot = _context.sent;
              receivers = snapshot.val() || {};
              _this.requestEmailReceivers = receivers.request || [];
              _this.companySubmissionEmailReceivers = receivers.companySubmission || [];
              _context.next = 13;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              snackbar = {
                active: true,
                text: 'An error occured while getting the email receivers.'
              };

              _this.$store.dispatch('triggerSnackbar', snackbar);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }))();
  },
  saveEmailReceivers: function saveEmailReceivers() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.mark(function _callee2() {
      var payload, snackbar;
      return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _this2.saving = true;
              payload = {
                request: _this2.requestEmailReceivers,
                companySubmission: _this2.companySubmissionEmailReceivers
              };
              _context2.next = 5;
              return _this2.$firebase.database().ref('email_receivers').set(payload);

            case 5:
              _this2.saving = false;
              _context2.next = 13;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              _this2.saving = false;
              snackbar = {
                active: true,
                text: 'An error occured while saving the email receivers.'
              };

              _this2.$store.dispatch('triggerSnackbar', snackbar);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 8]]);
    }))();
  }
}), _data$mounted$compute;

/***/ }),

/***/ 1295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = {
  props: ['items', 'submitData', 'loading', 'type', 'data'],
  computed: {
    allData: function allData() {
      var _this = this;

      var data = {};
      this.items.forEach(function (element) {
        data[element] = _this.data[element];
      });
      return data;
    }
  },
  methods: {
    saveData: function saveData(data, block) {
      var type = "".concat(this.type, "/").concat(block);
      var values = {
        type: type,
        data: data
      };
      this.submitData(values);
    }
  },
  data: function data() {
    return {
      values: {}
    };
  }
};

/***/ }),

/***/ 1296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = {
  props: ['items', 'submitData', 'loading', 'type', 'data'],
  data: function data() {
    return {
      values: {
        type: this.type,
        data: this.data
      }
    };
  },
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    }
  }
};

/***/ }),

/***/ 1297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pages_landing_vue__ = __webpack_require__(1599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pages_landing_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Pages_landing_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Appearance_landing_vue__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Appearance_landing_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Appearance_landing_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Appearance_general_vue__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Appearance_general_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Appearance_general_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Pages_opportunities_vue__ = __webpack_require__(1600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Pages_opportunities_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Pages_opportunities_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Pages_directory_vue__ = __webpack_require__(1593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Pages_directory_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Pages_directory_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Pages_bid_alert_vue__ = __webpack_require__(1592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Pages_bid_alert_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Pages_bid_alert_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Pages_questionnaire_vue__ = __webpack_require__(1601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Pages_questionnaire_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Pages_questionnaire_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Pages_history_vue__ = __webpack_require__(1598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Pages_history_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Pages_history_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Pages_favorites_vue__ = __webpack_require__(1596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Pages_favorites_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Pages_favorites_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Pages_dod_contract_analytics_vue__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Pages_dod_contract_analytics_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Pages_dod_contract_analytics_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Pages_tracking_vue__ = __webpack_require__(1605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Pages_tracking_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Pages_tracking_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Pages_resources_vue__ = __webpack_require__(1603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Pages_resources_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Pages_resources_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Pages_award_vue__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Pages_award_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__Pages_award_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Pages_recovery_vue__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Pages_recovery_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__Pages_recovery_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Pages_forecast_vue__ = __webpack_require__(1597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Pages_forecast_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__Pages_forecast_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Pages_email_settings__ = __webpack_require__(1595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Pages_email_settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__Pages_email_settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Components_NavBar_vue__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Components_NavBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__Components_NavBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_main_menu_MainMenuComponent_vue__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_main_menu_MainMenuComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_main_menu_MainMenuComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Toolbar_vue__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Toolbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_Toolbar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Components_AdminSideBar_vue__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Components_AdminSideBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__Components_AdminSideBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Components_PageFooter_vue__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Components_PageFooter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__Components_PageFooter_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





















/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    Landing: __WEBPACK_IMPORTED_MODULE_0__Pages_landing_vue___default.a,
    LandingAppearance: __WEBPACK_IMPORTED_MODULE_1__Appearance_landing_vue___default.a,
    GeneralAppearance: __WEBPACK_IMPORTED_MODULE_2__Appearance_general_vue___default.a,
    NavBar: __WEBPACK_IMPORTED_MODULE_16__Components_NavBar_vue___default.a,
    MainMenu: __WEBPACK_IMPORTED_MODULE_17__components_main_menu_MainMenuComponent_vue___default.a,
    BidAlert: __WEBPACK_IMPORTED_MODULE_5__Pages_bid_alert_vue___default.a,
    AdminSideBarMenu: __WEBPACK_IMPORTED_MODULE_19__Components_AdminSideBar_vue___default.a,
    UserToolbar: __WEBPACK_IMPORTED_MODULE_18__components_Toolbar_vue___default.a,
    Opportunities: __WEBPACK_IMPORTED_MODULE_3__Pages_opportunities_vue___default.a,
    Directory: __WEBPACK_IMPORTED_MODULE_4__Pages_directory_vue___default.a,
    Questionnaire: __WEBPACK_IMPORTED_MODULE_6__Pages_questionnaire_vue___default.a,
    Resources: __WEBPACK_IMPORTED_MODULE_11__Pages_resources_vue___default.a,
    History: __WEBPACK_IMPORTED_MODULE_7__Pages_history_vue___default.a,
    Favorites: __WEBPACK_IMPORTED_MODULE_8__Pages_favorites_vue___default.a,
    DodContractAnalytics: __WEBPACK_IMPORTED_MODULE_9__Pages_dod_contract_analytics_vue___default.a,
    Tracking: __WEBPACK_IMPORTED_MODULE_10__Pages_tracking_vue___default.a,
    Awarded: __WEBPACK_IMPORTED_MODULE_12__Pages_award_vue___default.a,
    EmailSettings: __WEBPACK_IMPORTED_MODULE_15__Pages_email_settings___default.a,
    Recovery: __WEBPACK_IMPORTED_MODULE_13__Pages_recovery_vue___default.a,
    Forecast: __WEBPACK_IMPORTED_MODULE_14__Pages_forecast_vue___default.a,
    PageFooter: __WEBPACK_IMPORTED_MODULE_20__Components_PageFooter_vue___default.a
  },
  computed: {
    pages: function pages() {
      return this.$store.getters.getPages;
    },
    styles: function styles() {
      return this.$store.getters.getStyles;
    }
  },
  data: function data() {
    return {
      drawer: true,
      h1: window.title,
      itemsz: ['General Settings', 'Landing Page', 'Opportunities', 'Directory', 'Questionnaire', 'History', 'Favorites', 'Tracking', 'Awarded', 'Recovery', 'Forecast'],
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
    };
  },
  methods: {
    onDismiss: function onDismiss() {
      this.$store.dispatch('setError', null);
      this.$store.dispatch('setProcess', 'null');
    },
    triggerDrawer: function triggerDrawer() {
      this.drawer = !this.drawer;
    },
    isSelectedTab: function isSelectedTab(tabName) {
      var urlSection = this.$route.params.id || 'general-settings';
      return tabName === urlSection;
    }
  },
  mounted: function mounted() {
    var payload = {
      meta: {
        'h1': 'Settings/Configuration',
        'title': 'Settings/Configuration',
        'description': 'Admin Settings',
        'keywords': '',
        'requiresAuth': true
      }
    };
    document.title = payload.meta.title;
    this.$store.commit('setHeaderInfo', payload);
  }
};

/***/ }),

/***/ 1337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue__);

/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    Block: __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue___default.a
  },
  props: ['settings'],
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    loading: function loading() {
      return this.$store.getters.getLoading;
    },
    error: function error() {
      return this.$store.getters.getError;
    },
    updateProcess: function updateProcess() {
      return this.$store.getters.getProcess === 'Settings Saved';
    },
    process: function process() {
      return this.$store.getters.getProcess;
    }
  },
  data: function data() {
    return {
      status: '',
      items: ['Edit Awarded Opportunities Page Header Text']
    };
  },
  methods: {
    submitData: function submitData(values) {
      this.$store.dispatch('savePageSettings', values);
    }
  }
};

/***/ }),

/***/ 1338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue__);

/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    Block: __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue___default.a
  },
  props: ['settings'],
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    loading: function loading() {
      return this.$store.getters.getLoading;
    },
    error: function error() {
      return this.$store.getters.getError;
    },
    updateProcess: function updateProcess() {
      return this.$store.getters.getProcess === 'Settings Saved';
    },
    process: function process() {
      return this.$store.getters.getProcess;
    }
  },
  data: function data() {
    return {
      status: '',
      items: ['Edit Bid Alerts Page Text']
    };
  },
  methods: {
    submitData: function submitData(values) {
      this.$store.dispatch('savePageSettings', values);
    }
  }
};

/***/ }),

/***/ 1339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue__);

/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    Block: __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue___default.a
  },
  props: ['settings'],
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    loading: function loading() {
      return this.$store.getters.getLoading;
    },
    error: function error() {
      return this.$store.getters.getError;
    },
    updateProcess: function updateProcess() {
      return this.$store.getters.getProcess === 'Settings Saved';
    },
    process: function process() {
      return this.$store.getters.getProcess;
    }
  },
  data: function data() {
    return {
      status: '',
      items: ['Edit Directory Page Header Text']
    };
  },
  methods: {
    submitData: function submitData(values) {
      this.$store.dispatch('savePageSettings', values);
    }
  }
};

/***/ }),

/***/ 1340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue__);

/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    Block: __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue___default.a
  },
  props: ['settings'],
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    loading: function loading() {
      return this.$store.getters.getLoading;
    },
    error: function error() {
      return this.$store.getters.getError;
    },
    updateProcess: function updateProcess() {
      return this.$store.getters.getProcess === 'Settings Saved';
    },
    process: function process() {
      return this.$store.getters.getProcess;
    }
  },
  data: function data() {
    return {
      status: '',
      items: ['Edit Favorites Page Text']
    };
  },
  methods: {
    submitData: function submitData(values) {
      this.$store.dispatch('savePageSettings', values);
    }
  }
};

/***/ }),

/***/ 1341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue__);

/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    Block: __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue___default.a
  },
  props: ['settings'],
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    loading: function loading() {
      return this.$store.getters.getLoading;
    },
    error: function error() {
      return this.$store.getters.getError;
    },
    updateProcess: function updateProcess() {
      return this.$store.getters.getProcess === 'Settings Saved';
    },
    process: function process() {
      return this.$store.getters.getProcess;
    }
  },
  data: function data() {
    return {
      status: '',
      items: ['Edit Forecast Opportunities Page Header Text']
    };
  },
  methods: {
    submitData: function submitData(values) {
      this.$store.dispatch('savePageSettings', values);
    }
  }
};

/***/ }),

/***/ 1342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue__);

/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    Block: __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue___default.a
  },
  props: ['settings'],
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    loading: function loading() {
      return this.$store.getters.getLoading;
    },
    error: function error() {
      return this.$store.getters.getError;
    },
    updateProcess: function updateProcess() {
      return this.$store.getters.getProcess === 'Settings Saved';
    },
    process: function process() {
      return this.$store.getters.getProcess;
    }
  },
  data: function data() {
    return {
      status: '',
      items: ['Edit History Page Text']
    };
  },
  methods: {
    submitData: function submitData(values) {
      this.$store.dispatch('savePageSettings', values);
    }
  }
};

/***/ }),

/***/ 1343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sections_multiple_blocks_vue__ = __webpack_require__(1604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sections_multiple_blocks_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__sections_multiple_blocks_vue__);


/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    Block: __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue___default.a,
    MultipleBlock: __WEBPACK_IMPORTED_MODULE_1__sections_multiple_blocks_vue___default.a
  },
  props: ['settings'],
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    loading: function loading() {
      return this.$store.getters.getLoading;
    },
    error: function error() {
      return this.$store.getters.getError;
    },
    updateProcess: function updateProcess() {
      return this.$store.getters.getProcess === 'Settings Saved';
    },
    process: function process() {
      return this.$store.getters.getProcess;
    }
  },
  data: function data() {
    return {
      status: '',
      ex11: true,
      faq_items: ['block1', 'block2', 'block3', 'block4'],
      footer_items: ['block1', 'block2', 'block3'],
      casestudies_items: ['block1', 'block2', 'block3'],
      intro_items: ['block1', 'block2', 'block3'],
      info_items: ['Information Title and Text'],
      jumbotron_items: ['Jumbotron Title and Text']
    };
  },
  methods: {
    submitData: function submitData(values, block) {
      values.from = 'landing_pages';
      this.$store.dispatch('savePageSettings', values);
    },
    onChange: function onChange(data, type) {
      var payload = {
        data: data,
        type: type,
        from: 'landing_pages'
      };
      this.$store.dispatch('savePageSettings', payload);
    }
  }
};

/***/ }),

/***/ 1344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue__);

/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    Block: __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue___default.a
  },
  props: ['settings'],
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    loading: function loading() {
      return this.$store.getters.getLoading;
    },
    error: function error() {
      return this.$store.getters.getError;
    },
    updateProcess: function updateProcess() {
      return this.$store.getters.getProcess === 'Settings Saved';
    },
    process: function process() {
      return this.$store.getters.getProcess;
    }
  },
  data: function data() {
    return {
      status: '',
      items: ['Edit Opportunities Page Text']
    };
  },
  methods: {
    submitData: function submitData(values) {
      this.$store.dispatch('savePageSettings', values);
    }
  }
};

/***/ }),

/***/ 1345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue__);

/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    Block: __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue___default.a
  },
  props: ['settings'],
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    loading: function loading() {
      return this.$store.getters.getLoading;
    },
    error: function error() {
      return this.$store.getters.getError;
    },
    updateProcess: function updateProcess() {
      return this.$store.getters.getProcess === 'Settings Saved';
    },
    process: function process() {
      return this.$store.getters.getProcess;
    }
  },
  data: function data() {
    return {
      status: '',
      items: ['Edit Questionnaire Page Text']
    };
  },
  methods: {
    submitData: function submitData(values) {
      this.$store.dispatch('savePageSettings', values);
    }
  }
};

/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue__);

/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    Block: __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue___default.a
  },
  props: ['settings'],
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    loading: function loading() {
      return this.$store.getters.getLoading;
    },
    error: function error() {
      return this.$store.getters.getError;
    },
    updateProcess: function updateProcess() {
      return this.$store.getters.getProcess === 'Settings Saved';
    },
    process: function process() {
      return this.$store.getters.getProcess;
    }
  },
  data: function data() {
    return {
      status: '',
      items: ['Edit Recovery Opportunities Page Header Text']
    };
  },
  methods: {
    submitData: function submitData(values) {
      this.$store.dispatch('savePageSettings', values);
    }
  }
};

/***/ }),

/***/ 1347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue__);

/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    Block: __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue___default.a
  },
  props: ['settings'],
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    loading: function loading() {
      return this.$store.getters.getLoading;
    },
    error: function error() {
      return this.$store.getters.getError;
    },
    updateProcess: function updateProcess() {
      return this.$store.getters.getProcess === 'Settings Saved';
    },
    process: function process() {
      return this.$store.getters.getProcess;
    }
  },
  data: function data() {
    return {
      status: '',
      items: ['Edit Resources Page Header Text']
    };
  },
  methods: {
    submitData: function submitData(values) {
      this.$store.dispatch('savePageSettings', values);
    }
  }
};

/***/ }),

/***/ 1348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue__);

/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    Block: __WEBPACK_IMPORTED_MODULE_0__sections_single_block_vue___default.a
  },
  props: ['settings'],
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    loading: function loading() {
      return this.$store.getters.getLoading;
    },
    error: function error() {
      return this.$store.getters.getError;
    },
    updateProcess: function updateProcess() {
      return this.$store.getters.getProcess === 'Settings Saved';
    },
    process: function process() {
      return this.$store.getters.getProcess;
    }
  },
  data: function data() {
    return {
      status: '',
      items: ['Edit Tracking Page Text']
    };
  },
  methods: {
    submitData: function submitData(values) {
      this.$store.dispatch('savePageSettings', values);
    }
  }
};

/***/ }),

/***/ 1361:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"directory.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1369:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"bid-alert.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1371:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"resources.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1377:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, "#tab-item[data-v-41646b5c]{min-width:18px;font-size:12px}#body_view[data-v-41646b5c]{margin-top:71px}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/PagesView.vue"],"names":[],"mappings":"AACA,2BACE,eAAgB,AAChB,cAAgB,CACjB,AACD,4BACE,eAAiB,CAClB","file":"PagesView.vue","sourcesContent":["\n#tab-item[data-v-41646b5c] {\n  min-width: 18px;\n  font-size: 12px;\n}\n#body_view[data-v-41646b5c] {\n  margin-top: 71px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1382:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, "#block{border:2px solid #ccc}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Pages/sections/multiple_blocks.vue"],"names":[],"mappings":"AACA,OACI,qBAAuB,CAC1B","file":"multiple_blocks.vue","sourcesContent":["\n#block {\n    border: #ccc solid 2px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1383:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".title-header[data-v-4cfbf695]{font-size:18px;text-align:center;left:0;color:#205c43}#tab-item[data-v-4cfbf695]{min-width:20px}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Pages/landing.vue"],"names":[],"mappings":"AACA,+BACE,eAAgB,AAChB,kBAAmB,AACnB,OAAQ,AACR,aAAe,CAChB,AACD,2BACE,cAAgB,CACjB","file":"landing.vue","sourcesContent":["\n.title-header[data-v-4cfbf695] {\n  font-size: 18px;\n  text-align: center;\n  left: 0;\n  color: #205c43;\n}\n#tab-item[data-v-4cfbf695] {\n  min-width: 20px;\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1406:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".input-group--select{margin-top:0!important}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Pages/email-settings.vue"],"names":[],"mappings":"AACA,qBACE,sBAAyB,CAC1B","file":"email-settings.vue","sourcesContent":["\n.input-group--select {\n  margin-top: 0 !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1450:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1361);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("3179e47e", content, true, {});

/***/ }),

/***/ 1458:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1369);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("4ca7922a", content, true, {});

/***/ }),

/***/ 1460:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1371);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("27ad22d1", content, true, {});

/***/ }),

/***/ 1466:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1377);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("b4efee42", content, true, {});

/***/ }),

/***/ 1471:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1382);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("92a649a2", content, true, {});

/***/ }),

/***/ 1472:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1383);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("897663f8", content, true, {});

/***/ }),

/***/ 1495:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1406);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("36f1decf", content, true, {});

/***/ }),

/***/ 1591:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1337),
  /* template */
  __webpack_require__(1723),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1592:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1458)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1338),
  /* template */
  __webpack_require__(1660),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-35ac610a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1593:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1450)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1339),
  /* template */
  __webpack_require__(1649),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-201bfe6b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1594:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1293),
  /* template */
  __webpack_require__(1634),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1595:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1495)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1294),
  /* template */
  __webpack_require__(1705),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1596:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1340),
  /* template */
  __webpack_require__(1698),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1597:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1341),
  /* template */
  __webpack_require__(1719),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1598:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1342),
  /* template */
  __webpack_require__(1670),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1599:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1472)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1343),
  /* template */
  __webpack_require__(1676),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4cfbf695",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1600:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1344),
  /* template */
  __webpack_require__(1689),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1601:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1345),
  /* template */
  __webpack_require__(1691),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1602:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1346),
  /* template */
  __webpack_require__(1659),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1603:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1460)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1347),
  /* template */
  __webpack_require__(1662),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-38020223",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1604:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1471)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1295),
  /* template */
  __webpack_require__(1675),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1605:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1348),
  /* template */
  __webpack_require__(1678),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1634:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "bordered-card"
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n      DoD Contract Analytics Page\n    ")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('block', {
    attrs: {
      "items": _vm.items,
      "submitData": _vm.submitData,
      "loading": _vm.loading,
      "type": "dod-contract-analytics",
      "data": _vm.settings
    }
  })], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 3000,
      "success": _vm.updateProcess,
      "error": _vm.status === 'error'
    },
    model: {
      value: (_vm.updateProcess),
      callback: function($$v) {
        _vm.updateProcess = $$v
      },
      expression: "updateProcess"
    }
  }, [_vm._v(_vm._s(_vm.process) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1635:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, _vm._l((_vm.items), function(i) {
    return _c('v-layout', {
      key: i,
      staticClass: "mt-2 pb-3",
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": ""
      }
    }, [_c('p', {
      staticClass: "settings-label subheader text-xs-right"
    }, [_vm._v(_vm._s(i))])]), _vm._v(" "), _c('v-flex', {
      staticClass: "pl-4",
      attrs: {
        "xs5": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "name": "input-1",
        "label": "Title Text",
        "id": "testing"
      },
      model: {
        value: (_vm.data.header),
        callback: function($$v) {
          _vm.$set(_vm.data, "header", $$v)
        },
        expression: "data.header"
      }
    }), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "name": "input-7-1",
        "label": "Subtitle Text",
        "multi-line": ""
      },
      model: {
        value: (_vm.data.sub_text),
        callback: function($$v) {
          _vm.$set(_vm.data, "sub_text", $$v)
        },
        expression: "data.sub_text"
      }
    }), _vm._v(" "), _c('v-btn', {
      style: ({
        backgroundColor: _vm.styles.general.theme_color_light
      }),
      attrs: {
        "color": "primary",
        "loading": _vm.loading,
        "disabled": _vm.loading,
        "id": _vm.type
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.submitData(_vm.values)
        }
      }
    }, [_vm._v("\n        Save\n        "), _c('span', {
      staticClass: "custom-loader",
      attrs: {
        "slot": "loader"
      },
      slot: "loader"
    }, [_c('v-icon', {
      attrs: {
        "light": ""
      }
    }, [_vm._v("cached")])], 1)])], 1)], 1)
  }), 1)
},staticRenderFns: []}

/***/ }),

/***/ 1649:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "bordered-card"
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n      Directory Page\n    ")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('block', {
    attrs: {
      "items": _vm.items,
      "submitData": _vm.submitData,
      "loading": _vm.loading,
      "type": "directory",
      "data": _vm.settings
    }
  })], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 3000,
      "success": _vm.updateProcess,
      "error": _vm.status === 'error'
    },
    model: {
      value: (_vm.updateProcess),
      callback: function($$v) {
        _vm.updateProcess = $$v
      },
      expression: "updateProcess"
    }
  }, [_vm._v(_vm._s(_vm.process) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1659:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "bordered-card"
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n      Recovery Opportunities Page\n    ")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('block', {
    attrs: {
      "items": _vm.items,
      "submitData": _vm.submitData,
      "loading": _vm.loading,
      "type": "recoveryopportunities",
      "data": _vm.settings
    }
  })], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 3000,
      "success": _vm.updateProcess,
      "error": _vm.status === 'error'
    },
    model: {
      value: (_vm.updateProcess),
      callback: function($$v) {
        _vm.updateProcess = $$v
      },
      expression: "updateProcess"
    }
  }, [_vm._v(_vm._s(_vm.process) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1660:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "bordered-card"
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n      Bid Alerts Page\n    ")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('block', {
    attrs: {
      "items": _vm.items,
      "submitData": _vm.submitData,
      "loading": _vm.loading,
      "type": "bid_alerts",
      "data": _vm.settings
    }
  })], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 3000,
      "success": _vm.updateProcess,
      "error": _vm.status === 'error'
    },
    model: {
      value: (_vm.updateProcess),
      callback: function($$v) {
        _vm.updateProcess = $$v
      },
      expression: "updateProcess"
    }
  }, [_vm._v(_vm._s(_vm.process) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1662:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "bordered-card"
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n      Resources Page\n    ")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('block', {
    attrs: {
      "items": _vm.items,
      "submitData": _vm.submitData,
      "loading": _vm.loading,
      "type": "resources",
      "data": _vm.settings
    }
  })], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 3000,
      "success": _vm.updateProcess,
      "error": _vm.status === 'error'
    },
    model: {
      value: (_vm.updateProcess),
      callback: function($$v) {
        _vm.updateProcess = $$v
      },
      expression: "updateProcess"
    }
  }, [_vm._v(_vm._s(_vm.process) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1669:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "height": "100%",
      "padding": "0"
    },
    attrs: {
      "fill-height": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "fill-height": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('AdminSideBarMenu'), _vm._v(" "), _c('v-flex', {
    staticClass: "dashboard-view"
  }, [(_vm.isSelectedTab('general-settings')) ? _c('div', [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("General Settings")])], 1), _vm._v(" "), _c('GeneralAppearance')], 1) : _vm._e(), _vm._v(" "), (_vm.isSelectedTab('email-settings')) ? _c('v-flex', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Email Settings")])], 1), _vm._v(" "), _c('EmailSettings')], 1) : _vm._e(), _vm._v(" "), (_vm.isSelectedTab('opportunities')) ? _c('v-flex', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Opportunities Settings")])], 1), _vm._v(" "), _c('Opportunities', {
    attrs: {
      "settings": _vm.pages.opportunities
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSelectedTab('directory')) ? _c('v-flex', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Directory Settings")])], 1), _vm._v(" "), _c('Directory', {
    attrs: {
      "settings": _vm.pages.directory
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSelectedTab('questionnaire')) ? _c('v-flex', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Questionnaire Settings")])], 1), _vm._v(" "), _c('Questionnaire', {
    attrs: {
      "settings": _vm.pages.questionnaire
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSelectedTab('history')) ? _c('v-flex', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("History Settings")])], 1), _vm._v(" "), _c('History', {
    attrs: {
      "settings": _vm.pages.history
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSelectedTab('favorites')) ? _c('v-flex', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Favorites Settings")])], 1), _vm._v(" "), _c('Favorites', {
    attrs: {
      "settings": _vm.pages.favorites
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSelectedTab('resources')) ? _c('v-flex', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Resources")])], 1), _vm._v(" "), _c('Resources', {
    attrs: {
      "settings": _vm.pages.resources
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSelectedTab('bid_alerts')) ? _c('v-flex', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Bid Alerts")])], 1), _vm._v(" "), _c('BidAlert', {
    attrs: {
      "settings": _vm.pages.bid_alerts || {}
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSelectedTab('tracking')) ? _c('v-flex', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Tracking Settings")])], 1), _vm._v(" "), _c('Tracking', {
    attrs: {
      "settings": _vm.pages.tracking
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSelectedTab('dod-contract-analytics')) ? _c('v-flex', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Settings")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("DoD Contract Analytics Settings")])], 1), _vm._v(" "), _c('dod-contract-analytics', {
    attrs: {
      "settings": _vm.pages['dod-contract-analytics'] || {}
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('PageFooter')], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1670:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "bordered-card"
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n      History Page\n    ")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('block', {
    attrs: {
      "items": _vm.items,
      "submitData": _vm.submitData,
      "loading": _vm.loading,
      "type": "history",
      "data": _vm.settings
    }
  })], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 3000,
      "success": _vm.updateProcess,
      "error": _vm.status === 'error'
    },
    model: {
      value: (_vm.updateProcess),
      callback: function($$v) {
        _vm.updateProcess = $$v
      },
      expression: "updateProcess"
    }
  }, [_vm._v(_vm._s(_vm.process) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1675:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "multiple-blocks"
  }, [_c('v-layout', {
    staticClass: "pb-3",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-4",
    attrs: {
      "xs5": "",
      "offset-xs3": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "color": "white",
      "fixed": ""
    }
  }, [_vm._l((_vm.items), function(i) {
    return _c('v-tab', {
      key: i,
      staticClass: "white lighten",
      attrs: {
        "href": '#tab-' + i,
        "id": 'tab-item-' + i
      }
    }, [_vm._v("\n          " + _vm._s(i) + "\n        ")])
  }), _vm._v(" "), _vm._l((_vm.items), function(i) {
    return _c('v-tab-item', {
      key: i,
      attrs: {
        "id": 'tab-' + i
      }
    }, [_c('v-card', {
      staticClass: "pt-4 pb-4"
    }, [_c('v-text-field', {
      attrs: {
        "name": "input-1",
        "label": "Title Text",
        "id": "testing"
      },
      model: {
        value: (_vm.allData[i].header),
        callback: function($$v) {
          _vm.$set(_vm.allData[i], "header", $$v)
        },
        expression: "allData[i].header"
      }
    }), _vm._v(" "), _c('v-text-field', {
      attrs: {
        "name": "input-7-1",
        "label": "Subtitle Text",
        "multi-line": ""
      },
      model: {
        value: (_vm.allData[i].sub_text),
        callback: function($$v) {
          _vm.$set(_vm.allData[i], "sub_text", $$v)
        },
        expression: "allData[i].sub_text"
      }
    }), _vm._v(" "), _c('v-btn', {
      attrs: {
        "loading": _vm.loading,
        "disabled": _vm.loading,
        "color": "primary",
        "id": _vm.type
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.saveData(_vm.allData[i], i)
        }
      }
    }, [_c('v-icon', [_vm._v("save")]), _vm._v("\n              Save\n              "), _c('span', {
      staticClass: "custom-loader",
      attrs: {
        "slot": "loader"
      },
      slot: "loader"
    }, [_c('v-icon', {
      attrs: {
        "light": ""
      }
    }, [_vm._v("cached")])], 1)], 1)], 1)], 1)
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1676:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "bordered-card",
    attrs: {
      "id": "right_section"
    }
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {}, [_vm._v("\n      Layout/Block Settings\n    ")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-view-grid")]), _vm._v(" Jumbotron Section\n          ")], 1), _vm._v(" "), _c('v-card', [_c('v-layout', {
    staticClass: "mt-2 pb-3",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "justify-end": true
    }
  }, [_c('v-list', {
    attrs: {
      "subheader": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "text-xs-right"
  }, [_vm._v("Enable Section")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "text-xs-right"
  }, [_vm._v("Make section visible on landing page")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4 pt-2",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-switch', {
    on: {
      "change": function($event) {
        return _vm.onChange(_vm.settings.jumbotron.enable, 'jumbotron/enable')
      }
    },
    model: {
      value: (_vm.settings.jumbotron.enable),
      callback: function($$v) {
        _vm.$set(_vm.settings.jumbotron, "enable", $$v)
      },
      expression: "settings.jumbotron.enable"
    }
  })], 1)], 1), _vm._v(" "), _c('block', {
    attrs: {
      "items": _vm.jumbotron_items,
      "submitData": _vm.submitData,
      "loading": _vm.loading,
      "type": "jumbotron",
      "data": _vm.settings.jumbotron
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-view-grid")]), _vm._v(" Information Section\n          ")], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 pb-3",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "justify-end": true
    }
  }, [_c('v-list', {
    attrs: {
      "subheader": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "text-xs-right"
  }, [_vm._v("Enable Section")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "text-xs-right"
  }, [_vm._v("Make section visible on landing page")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4 pt-2",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-switch', {
    on: {
      "change": function($event) {
        return _vm.onChange(_vm.settings.info_section.enable, 'info_section/enable')
      }
    },
    model: {
      value: (_vm.settings.info_section.enable),
      callback: function($$v) {
        _vm.$set(_vm.settings.info_section, "enable", $$v)
      },
      expression: "settings.info_section.enable"
    }
  })], 1)], 1), _vm._v(" "), _c('block', {
    attrs: {
      "items": _vm.info_items,
      "submitData": _vm.submitData,
      "loading": _vm.loading,
      "type": "info_section",
      "data": _vm.settings.info_section
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-view-grid")]), _vm._v(" Introduction Section\n          ")], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 pb-3",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "justify-end": true
    }
  }, [_c('v-list', {
    attrs: {
      "subheader": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "text-xs-right"
  }, [_vm._v("Enable Section")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "text-xs-right"
  }, [_vm._v("Make section visible on landing page")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4 pt-2",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-switch', {
    on: {
      "change": function($event) {
        return _vm.onChange(_vm.settings.intro_section.enable, 'intro_section/enable')
      }
    },
    model: {
      value: (_vm.settings.intro_section.enable),
      callback: function($$v) {
        _vm.$set(_vm.settings.intro_section, "enable", $$v)
      },
      expression: "settings.intro_section.enable"
    }
  })], 1)], 1), _vm._v(" "), _c('multiple-block', {
    attrs: {
      "items": _vm.intro_items,
      "submitData": _vm.submitData,
      "loading": _vm.loading,
      "type": "intro_section",
      "data": _vm.settings.intro_section
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-view-grid")]), _vm._v(" FAQ Section\n          ")], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 pb-3",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "justify-end": true
    }
  }, [_c('v-list', {
    attrs: {
      "subheader": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "text-xs-right"
  }, [_vm._v("Enable Section")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "text-xs-right"
  }, [_vm._v("Make FAQ Section visible on landing page")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4 pt-2",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-switch', {
    on: {
      "change": function($event) {
        return _vm.onChange(_vm.settings.faq.enable, 'faq/enable')
      }
    },
    model: {
      value: (_vm.settings.faq.enable),
      callback: function($$v) {
        _vm.$set(_vm.settings.faq, "enable", $$v)
      },
      expression: "settings.faq.enable"
    }
  })], 1)], 1), _vm._v(" "), _c('multiple-block', {
    attrs: {
      "items": _vm.faq_items,
      "submitData": _vm.submitData,
      "loading": _vm.loading,
      "type": "faq",
      "data": _vm.settings.faq
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-view-grid")]), _vm._v(" Case Studies\n          ")], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 pb-3",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "justify-end": true
    }
  }, [_c('v-list', {
    attrs: {
      "subheader": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "text-xs-right"
  }, [_vm._v("Enable Section")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "text-xs-right"
  }, [_vm._v("Make Case Studies section visible on landing page")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4 pt-2",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-switch', {
    on: {
      "change": function($event) {
        return _vm.onChange(_vm.settings.case_studies.enable, 'case_studies/enable')
      }
    },
    model: {
      value: (_vm.settings.case_studies.enable),
      callback: function($$v) {
        _vm.$set(_vm.settings.case_studies, "enable", $$v)
      },
      expression: "settings.case_studies.enable"
    }
  })], 1)], 1), _vm._v(" "), _c('multiple-block', {
    attrs: {
      "items": _vm.casestudies_items,
      "submitData": _vm.submitData,
      "loading": _vm.loading,
      "type": "case_studies",
      "data": _vm.settings.case_studies
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-view-grid")]), _vm._v(" Footer Studies\n          ")], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 pb-3",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "justify-end": true
    }
  }, [_c('v-list', {
    attrs: {
      "subheader": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "text-xs-right"
  }, [_vm._v("Enable Footer Section")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "text-xs-right"
  }, [_vm._v("Make section visible on landing page")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4 pt-2",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-switch', {
    on: {
      "change": function($event) {
        return _vm.onChange(_vm.settings.footer.enable, 'footer/enable')
      }
    },
    model: {
      value: (_vm.settings.footer.enable),
      callback: function($$v) {
        _vm.$set(_vm.settings.footer, "enable", $$v)
      },
      expression: "settings.footer.enable"
    }
  })], 1)], 1), _vm._v(" "), _c('multiple-block', {
    attrs: {
      "items": _vm.footer_items,
      "submitData": _vm.submitData,
      "loading": _vm.loading,
      "type": "footer",
      "data": _vm.settings.footer
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1678:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "bordered-card"
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n      Tracking Page\n    ")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('block', {
    attrs: {
      "items": _vm.items,
      "submitData": _vm.submitData,
      "loading": _vm.loading,
      "type": "tracking",
      "data": _vm.settings
    }
  })], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 3000,
      "success": _vm.updateProcess,
      "error": _vm.status === 'error'
    },
    model: {
      value: (_vm.updateProcess),
      callback: function($$v) {
        _vm.updateProcess = $$v
      },
      expression: "updateProcess"
    }
  }, [_vm._v(_vm._s(_vm.process) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1689:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "bordered-card"
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n      Opportunities Page\n    ")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('block', {
    attrs: {
      "items": _vm.items,
      "submitData": _vm.submitData,
      "loading": _vm.loading,
      "type": "opportunities",
      "data": _vm.settings
    }
  })], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 3000,
      "success": _vm.updateProcess,
      "error": _vm.status === 'error'
    },
    model: {
      value: (_vm.updateProcess),
      callback: function($$v) {
        _vm.updateProcess = $$v
      },
      expression: "updateProcess"
    }
  }, [_vm._v(_vm._s(_vm.process) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1691:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "bordered-card"
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n      Questionnaire Page\n    ")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('block', {
    attrs: {
      "items": _vm.items,
      "submitData": _vm.submitData,
      "loading": _vm.loading,
      "type": "questionnaire",
      "data": _vm.settings
    }
  })], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 3000,
      "success": _vm.updateProcess,
      "error": _vm.status === 'error'
    },
    model: {
      value: (_vm.updateProcess),
      callback: function($$v) {
        _vm.updateProcess = $$v
      },
      expression: "updateProcess"
    }
  }, [_vm._v(_vm._s(_vm.process) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1698:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "bordered-card"
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n      Favorites Page\n    ")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('block', {
    attrs: {
      "items": _vm.items,
      "submitData": _vm.submitData,
      "loading": _vm.loading,
      "type": "favorites",
      "data": _vm.settings
    }
  })], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 3000,
      "success": _vm.updateProcess,
      "error": _vm.status === 'error'
    },
    model: {
      value: (_vm.updateProcess),
      callback: function($$v) {
        _vm.updateProcess = $$v
      },
      expression: "updateProcess"
    }
  }, [_vm._v(_vm._s(_vm.process) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1705:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "bordered-card"
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n      Email Settings\n    ")])], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-4"
  }, [_c('v-form', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.adminUsers,
      "label": "Request Email Receivers",
      "item-avatar": "avatar",
      "item-text": "fullName",
      "item-value": "uid",
      "multiple": "",
      "autocomplete": "",
      "deletable-chips": "",
      "clearable": "",
      "chips": ""
    },
    model: {
      value: (_vm.requestEmailReceivers),
      callback: function($$v) {
        _vm.requestEmailReceivers = $$v
      },
      expression: "requestEmailReceivers"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.adminUsers,
      "label": "Company Submission Email Receivers",
      "item-avatar": "avatar",
      "item-text": "fullName",
      "item-value": "uid",
      "multiple": "",
      "autocomplete": "",
      "deletable-chips": "",
      "clearable": "",
      "chips": ""
    },
    model: {
      value: (_vm.companySubmissionEmailReceivers),
      callback: function($$v) {
        _vm.companySubmissionEmailReceivers = $$v
      },
      expression: "companySubmissionEmailReceivers"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "disabled": _vm.saving,
      "loading": _vm.saving,
      "color": "primary"
    },
    on: {
      "click": _vm.saveEmailReceivers
    }
  }, [_vm._v("\n            Save\n          ")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1719:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "bordered-card"
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n      Forecast Opportunities Page\n    ")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('block', {
    attrs: {
      "items": _vm.items,
      "submitData": _vm.submitData,
      "loading": _vm.loading,
      "type": "forecastopportunities",
      "data": _vm.settings
    }
  })], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 3000,
      "success": _vm.updateProcess,
      "error": _vm.status === 'error'
    },
    model: {
      value: (_vm.updateProcess),
      callback: function($$v) {
        _vm.updateProcess = $$v
      },
      expression: "updateProcess"
    }
  }, [_vm._v(_vm._s(_vm.process) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1723:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "bordered-card"
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n      Awarded Opportunities Page\n    ")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('block', {
    attrs: {
      "items": _vm.items,
      "submitData": _vm.submitData,
      "loading": _vm.loading,
      "type": "awardedopportunities",
      "data": _vm.settings
    }
  })], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 3000,
      "success": _vm.updateProcess,
      "error": _vm.status === 'error'
    },
    model: {
      value: (_vm.updateProcess),
      callback: function($$v) {
        _vm.updateProcess = $$v
      },
      expression: "updateProcess"
    }
  }, [_vm._v(_vm._s(_vm.process) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1466)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1297),
  /* template */
  __webpack_require__(1669),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-41646b5c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 841:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(844)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(842),
  /* template */
  __webpack_require__(846),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-060504ef",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 842:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_font_awesome_css_font_awesome_min_css__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_font_awesome_css_font_awesome_min_css__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      items: [{
        icon: '',
        text: 'Home',
        link: '/admin/settings/home'
      }, {
        icon: '',
        text: 'Settings',
        link: '/admin/settings/pages',
        children: [{
          icon: '',
          text: 'General Settings',
          link: '/admin/settings/pages',
          query: {
            page: 'general-settings'
          }
        }, {
          icon: '',
          text: 'Email Settings',
          link: '/admin/settings/pages',
          query: {
            page: 'email-settings'
          }
        }, {
          icon: '',
          text: 'Directory',
          link: '/admin/settings/pages',
          query: {
            page: 'directory'
          }
        }, {
          icon: '',
          text: 'Resources',
          link: '/admin/settings/pages',
          query: {
            page: 'resources'
          }
        }, {
          icon: '',
          text: 'Opportunities',
          link: '/admin/settings/pages',
          query: {
            page: 'opportunities'
          }
        }, {
          icon: '',
          text: 'History',
          link: '/admin/settings/pages',
          query: {
            page: 'history'
          }
        }, {
          icon: '',
          text: 'DoD Contract Analytics',
          link: '/admin/settings/pages',
          query: {
            page: 'dod-contract-analytics'
          }
        }, {
          icon: '',
          text: 'Bid Alerts',
          link: '/admin/settings/pages',
          query: {
            page: 'bid_alerts'
          }
        }, {
          icon: '',
          text: 'Questionnaire',
          link: '/admin/settings/pages',
          query: {
            page: 'questionnaire'
          }
        }, {
          icon: '',
          text: 'Favorites',
          link: '/admin/settings/pages',
          query: {
            page: 'favorites'
          }
        }, {
          icon: '',
          text: 'Tracking',
          link: '/admin/settings/pages',
          query: {
            page: 'tracking'
          }
        }]
      }, {
        icon: '',
        text: 'Users',
        link: '/admin/settings/users',
        children: [{
          icon: '',
          text: 'Manage Users',
          link: '/admin/settings/users',
          query: {
            page: 'manage-users'
          }
        }, {
          icon: '',
          text: 'Usage Tracking',
          link: '/admin/settings/users',
          query: {
            page: 'usage-tracking'
          }
        }, {
          icon: '',
          text: 'Default Chat Contact',
          link: '/admin/settings/users',
          query: {
            page: 'default-chat-contact'
          }
        }]
      }, {
        icon: '',
        text: 'Access',
        link: '/admin/settings/priviledges'
      }, {
        icon: '',
        text: 'Resources',
        link: '/admin/resources/all'
      }, {
        icon: '',
        text: 'Companies',
        link: '/admin/companies',
        children: [{
          icon: '',
          text: 'Update Company',
          link: '/admin/companies/update-company'
        }, {
          icon: '',
          text: 'Add Company',
          link: '/admin/companies/add-company'
        }]
      }, {
        icon: '',
        text: 'Requests',
        link: '/admin/settings/requests',
        children: [{
          icon: '',
          text: 'Activity Stream',
          link: '/admin/settings/requests',
          query: {
            page: 'activity'
          }
        }, {
          icon: '',
          text: 'Events',
          link: '/admin/settings/requests',
          query: {
            page: 'events'
          }
        }, {
          icon: '',
          text: 'Company Submission',
          link: '/admin/settings/requests',
          query: {
            page: 'companies'
          }
        } // {
        //   icon: '',
        //   text: 'Group Post',
        //   link: '/admin/settings/requests',
        //   query: {
        //     page: 'groups'
        //   }
        // },
        // {
        //   icon: '',
        //   text: 'Group Events',
        //   link: '/admin/settings/requests',
        //   query: {
        //     page: 'group-events'
        //   }
        // }
        ]
      }, {
        icon: '',
        text: 'Feedback/Support',
        link: '/admin/settings/support',
        children: [{
          text: 'Feedback',
          link: '/admin/settings/support',
          query: {
            page: 'feedback'
          }
        }, {
          text: 'Help Requests',
          link: '/admin/settings/support',
          query: {
            page: 'help-requests'
          }
        }]
      }, {
        icon: '',
        text: 'Admin Tutorials',
        link: '/admin/settings/tutorials',
        children: [{
          text: 'All Tutorials',
          link: '/admin/settings/tutorials',
          query: {
            page: 'all'
          }
        }, {
          text: 'Manage Tutorials',
          link: '/admin/settings/tutorials',
          query: {
            page: 'manage'
          }
        }]
      }]
    };
  },
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    }
  },
  methods: {
    checkUserRole: function checkUserRole() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var usr, fb, user, alert;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                usr = _this.$store.getters.getUserDetails;
                fb = _this.$firebase.database().ref();
                _context.next = 4;
                return fb.child('users/' + usr.uid.toString()).once('value');

              case 4:
                user = _context.sent;

                if (user.role !== 1) {
                  alert = {
                    ative: true,
                    header: 'Access denied',
                    text: "You don't have access on this page",
                    okText: 'Ok',
                    cancelText: ''
                  };

                  _this.$store.dispatch('triggerAlert', alert);

                  _this.$router.push('/user/feed');
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    isOpen: function isOpen(rootPath) {
      return this.$route.fullPath.indexOf(rootPath) > -1;
    }
  }
};

/***/ }),

/***/ 843:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".sidebar-menu[data-v-060504ef]{top:55px}.list__tile--active[data-v-060504ef],.list__tile--active[data-v-060504ef]:hover{background-color:rgba(0,0,0,.1)!important}.menu_list_data[data-v-060504ef]{width:100%}.menu_list_data li[data-v-060504ef]{margin-bottom:12px;padding-right:20px}.menu_list_item_data[data-v-060504ef]{font-size:16px}.list__group i[data-v-060504ef],.list__tile i[data-v-060504ef]{color:#a2a2a2}.list__tile__action[data-v-060504ef]{min-width:30px}.list__group__header--active[data-v-060504ef],.list__group__items[data-v-060504ef]{background-color:rgba(0,0,0,.4)}.list[data-v-060504ef]{background:transparent!important}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Components/AdminSideBar.vue"],"names":[],"mappings":"AACA,+BACE,QAAU,CACX,AAID,gFACE,yCAAgD,CACjD,AACD,iCACE,UAAY,CACb,AACD,oCACE,mBAAoB,AACpB,kBAAoB,CACrB,AACD,sCACE,cAAgB,CACjB,AACD,+DACE,aAAe,CAChB,AACD,qCACE,cAAgB,CACjB,AAID,mFACE,+BAAqC,CACtC,AACD,uBACE,gCAAmC,CACpC","file":"AdminSideBar.vue","sourcesContent":["\n.sidebar-menu[data-v-060504ef] {\n  top: 55px;\n}\n.list__tile--active[data-v-060504ef] {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n.list__tile--active[data-v-060504ef]:hover {\n  background-color: rgba(0, 0, 0, 0.1) !important;\n}\n.menu_list_data[data-v-060504ef] {\n  width: 100%;\n}\n.menu_list_data li[data-v-060504ef] {\n  margin-bottom: 12px;\n  padding-right: 20px;\n}\n.menu_list_item_data[data-v-060504ef] {\n  font-size: 16px;\n}\n.list__group i[data-v-060504ef], .list__tile i[data-v-060504ef] {\n  color: #a2a2a2;\n}\n.list__tile__action[data-v-060504ef] {\n  min-width: 30px;\n}\n.list__group__items[data-v-060504ef] {\n  background-color: rgba(0, 0, 0, 0.4);\n}\n.list__group__header--active[data-v-060504ef] {\n  background-color: rgba(0, 0, 0, 0.4);\n}\n.list[data-v-060504ef] {\n  background: transparent !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 844:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(843);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("91f344b8", content, true, {});

/***/ }),

/***/ 846:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navigation-drawer', {
    staticClass: "sidebar-menu",
    style: ({
      backgroundColor: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "dark": "",
      "fixed": "",
      "value": true,
      "mobile-break-point": 768,
      "clipped": true
    }
  }, [_c('v-list', {
    staticClass: "menu_list_data",
    attrs: {
      "dark": ""
    }
  }, _vm._l((_vm.items), function(item, i) {
    return (item.children) ? _c('v-list-group', {
      key: i,
      attrs: {
        "value": _vm.isOpen(item.link)
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "activator",
        "color": "grey"
      },
      slot: "activator"
    }, [_c('v-list-tile-action', [_c('v-icon', {
      staticClass: "menu_list_item_data",
      attrs: {
        "color": "white"
      }
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "white--text menu_list_item_data"
    }, [_vm._v("\n            " + _vm._s(item.text) + "\n          ")])], 1)], 1), _vm._v(" "), _vm._l((item.children), function(sub_item, i) {
      return _c('v-list-tile', {
        key: i,
        attrs: {
          "router": "",
          "to": sub_item.query ? ((sub_item.link) + "/" + (sub_item.query.page)) : ("" + (sub_item.link))
        }
      }, [_c('v-list-tile-action', [_c('v-icon', {
        staticClass: "menu_list_item_data",
        attrs: {
          "color": "white"
        }
      }, [_vm._v(_vm._s(sub_item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
        staticClass: "white--text menu_list_item_data"
      }, [_vm._v("\n            " + _vm._s(sub_item.text) + "\n          ")])], 1)], 1)
    })], 2) : _c('v-list-tile', {
      attrs: {
        "router": "",
        "to": item.link
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      staticClass: "menu_list_item_data",
      attrs: {
        "color": "white"
      }
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "white--text menu_list_item_data"
    }, [_vm._v("\n          " + _vm._s(item.text) + "\n        ")])], 1)], 1)
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".page-footer[data-v-1c309d0c]{position:absolute;height:50px;right:0;bottom:0;left:300px;background:#f9f9fa;border-top:1px solid #e1e6ef;text-align:center;line-height:50px;color:#151b1e}.page-footer p[data-v-1c309d0c]{margin:0}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Components/PageFooter.vue"],"names":[],"mappings":"AACA,8BACE,kBAAmB,AACnB,YAAa,AACb,QAAS,AACT,SAAU,AACV,WAAY,AACZ,mBAAoB,AACpB,6BAA8B,AAC9B,kBAAmB,AACnB,iBAAkB,AAClB,aAAe,CAChB,AACD,gCACI,QAAU,CACb","file":"PageFooter.vue","sourcesContent":["\n.page-footer[data-v-1c309d0c] {\n  position: absolute;\n  height: 50px;\n  right: 0;\n  bottom: 0;\n  left: 300px;\n  background: #f9f9fa;\n  border-top: 1px solid #e1e6ef;\n  text-align: center;\n  line-height: 50px;\n  color: #151b1e;\n}\n.page-footer p[data-v-1c309d0c] {\n    margin: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 873:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(871);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("2eac6325", content, true, {});

/***/ }),

/***/ 876:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(873)
}
var Component = __webpack_require__(14)(
  /* script */
  null,
  /* template */
  __webpack_require__(877),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1c309d0c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 877:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-footer mt-4"
  }, [_c('p', [_vm._v("Georgia Defense-Exchange")])])
}]}

/***/ }),

/***/ 943:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1296),
  /* template */
  __webpack_require__(1635),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/2.6ad642406199aa3b05ac.js